import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: `
  <app-nav-bar></app-nav-bar>
  <router-outlet></router-outlet>
  <app-footer></app-footer>`
  //styleUrls: ['./app.component.scss'] 
})
export class AppComponent {
  title = 'app';
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/app.component.ts